<template>
    <div class="live">
        <div class="title-container">直播管理</div>
        <div class="search-container">
            <el-form ref="form" :model="queryParams">
                <el-form-item label="直播状态：">
                    <el-select v-model="queryParams.status" placeholder="请选择">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="未开始" value="0"></el-option>
                        <el-option label="直播中" value="1"></el-option>
                        <el-option label="已结束" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item >
                    <el-input v-model="queryParams.title" @keypress.native.enter="search" placeholder="输入直播名称"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-input v-model="queryParams.id" @keypress.native.enter="search" placeholder="输入频道号"></el-input>
                </el-form-item>
                <el-form-item >
                    <el-button type="primary" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="live-container">
            <div class="mg-bottom16">
                <el-button type="primary" size="small" @click="openLive()">新建直播</el-button>
            </div>
            <div class="table-container">
                <el-table :data="tableData" border v-loading="listLoading">
                    <el-table-column prop="id" label="频道号" min-width="100"></el-table-column>
                    <el-table-column prop="title" label="直播名称" min-width="150"></el-table-column>
                    <el-table-column label="直播状态" min-width="90">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">
                                <i class="iconfont icon-dian" style="color: #E94D41"></i>未开始
                            </span>
                            <span v-if="scope.row.status == 1">
                                <i class="iconfont icon-dian" style="color: #1678FF"></i>直播中
                            </span>
                            <span v-if="scope.row.status == 2">
                                <i class="iconfont icon-dian" style="color: #A3A4B3"></i>已结束
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="begin_time" label="开播时间" min-width="160"></el-table-column>
                    <el-table-column prop="end_time" label="结束时间" min-width="160"></el-table-column>
                    <el-table-column label="直播时长" min-width="120">
                        <template slot-scope="scope">
                            <span>{{ scope.row.duration | formatDate }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="240">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="openLive(scope.row.id)">编辑</el-button>
                            <el-button type="text" size="medium" @click="liveLink(scope.row.id)">直播链接</el-button>
                            <el-button type="text" size="medium" @click="goSetup(scope.row.id, 'detail')">设置</el-button>
                            <el-button type="text" size="medium" @click="goSetup(scope.row.id, 'statistics')">统计</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-container text-align-right">
                <Pagination v-bind:child-msg="pageParams" @pageChange="pageChange" />
            </div>
        </div>
        <div v-if="liveLinkDialog">
            <el-dialog :title="dialogTitle" :visible.sync="liveLinkDialog" width="660px">
                <el-alert
                    title="将服务器地址和串流密钥分享给讲师，讲师通过OBS立即开播"
                    type="warning"
                    show-icon
                    :closable="false">
                </el-alert>
                <div class="mg-top16">
                    <el-form :inline="true" label-width="110px" label-position="left">
                        <div class="liveLink-content mg-bottom24">
                            <div class="liveLink-title">讲师</div>
                        </div>
                        <div class="liveLink-from">
                            <el-form-item label="服务器地址：">
                                <el-input v-model="serverAddress" disabled style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" :data-clipboard-text="serverAddress" class="clipboard" @click="copy">复制</el-button>
                            </el-form-item>
                        </div>
                        <div class="liveLink-from">
                            <el-form-item label="串流密钥：">
                                <el-input v-model="streamingKey" disabled style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" :data-clipboard-text="streamingKey" class="clipboard" @click="copy">复制</el-button>
                            </el-form-item>
                        </div>
                        <div class="liveLink-from">
                            <el-form-item label="网页直播链接：">
                                <el-input v-model="launchLink" disabled style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" :data-clipboard-text="launchLink" class="clipboard" @click="copy">复制</el-button>
                            </el-form-item>
                        </div>
                        <div class="liveLink-content mg-bottom24">
                            <div class="liveLink-title">观众</div>
                        </div>
                        <div class="liveLink-from">
                            <el-form-item label="网页观看链接：">
                                <el-input v-model="watchLink" disabled style="width:400px;"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="text" :data-clipboard-text="watchLink" class="clipboard" @click="copy">复制</el-button>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
            </el-dialog>
        </div>
        <div v-if="liveDialog">
            <el-dialog :title="dialogTitle" :visible.sync="liveDialog" width="580px">
                <div class="liveForm-content">
                    <el-form :model="liveForm" :rules="liveRule" ref="liveForm" label-width="127px" label-position="left">
                        <el-form-item label="直播名称：" prop="title">
                            <el-input v-model="liveForm.title" placeholder="给直播起个名字"></el-input>
                        </el-form-item>
                        <el-form-item label="直播间密码：" prop="password">
                            <el-input v-model="liveForm.password" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="讲师昵称：" prop="lecturer">
                            <el-input v-model="liveForm.lecturer" placeholder="请输入"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="直播场景：" required>
                            <el-radio-group v-model="liveForm.resource">
                                <el-radio label="互动课堂"></el-radio>
                            </el-radio-group>
                        </el-form-item> -->
                        <el-form-item label="开播时间：" prop="begin_time">
                            <el-date-picker
                                v-model="liveForm.begin_time"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="pickerOptions"
                                placeholder="设置直播开始时间" style="width: 100%;">
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="串流密钥有效期：" prop="expire_time" v-if="!liveId">
                            <el-input placeholder="请输入" v-model="liveForm.expire_time">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item> -->
                        <el-form-item label="直播封面：" prop="cover">
                            <SingleUpload v-bind:child-msg="uploadParams" v-on:imageUrl="imageUrl($event)" />
                        </el-form-item>
                        <el-form-item label="直播介绍：" prop="intro">
                            <el-input type="textarea" placeholder="请输入关于直播内容的介绍" v-model="liveForm.intro" rows='7' maxlength="128" show-word-limit></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small" @click="liveDialog = false" >取 消</el-button>
                    <el-button type="primary" :loading="loading" size="small" @click="handleLive">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { getLive, addLive, editLive, detailLive, liveHref } from '@/api/live/index'
import Clipboard from 'clipboard'

import Pagination from '@/components/Pagination'
import SingleUpload from '@/components/SingleUpload'

export default {
    inject: ['reload'],
    name: 'live',
    data () {
        const validatePass = (rule, value, callback) => {
            if (!value) {
                callback(new Error('密码不能为空'))
            } else {
                const reg = /.*[\u4e00-\u9fa5]+.*$/
                if (reg.test(value)) {
                    return callback(new Error('密码不能包含汉字'))
                } else {
                    callback()
                }
            }
        }
        const expireTime = (rule, value, callback) => {
            if (!value) {
                callback(new Error('串流密钥有效期不能为空'))
            } else {
                const reg = /\D|^0/g
                if (reg.test(value)) {
                    return callback(new Error('串流密钥有效期只能为数字'))
                } else {
                    callback()
                }
            }
        }
        const validateIntro = (rule, value, callback) => {
            if (!value) {
                callback(new Error('直播介绍不能为空'))
            } else {
                if (value.length > 128) {
                    return callback(new Error('直播频道介绍最大长度为128'))
                } else {
                    callback()
                }
            }
        }
        return {
            listLoading: false,
            loading: false,
            queryParams: {
                page: 1,
                per_page: 10
            },
            pageParams: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            tableData: [],
            liveLinkDialog: false,
            serverAddress: '',
            streamingKey: '',
            watchLink: '',
            launchLink: '',
            liveId: '',
            dialogTitle: '',
            liveDialog: false,
            liveForm: {},
            liveRule: {
                title: [
                    { required: true, message: '名称不能为空', trigger: 'blur' }
                ],
                password: [
                    { required: true, validator: validatePass, trigger: 'blur' }
                ],
                lecturer: [
                    { required: true, message: '讲师昵称不能为空', trigger: 'blur' }
                ],
                begin_time: [
                    { required: true, message: '开播时间不能为空', trigger: 'blur' }
                ],
                // expire_time: [
                //     { required: true, validator: expireTime, trigger: 'blur' }
                // ],
                cover: [
                    { required: true, message: '直播封面不能为空', trigger: 'blur' }
                ],
                intro: [
                    { required: true, validator: validateIntro, trigger: 'blur' }
                ]
            },
            pickerOptions: {
                disabledDate(date) {
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000
                }
            },
            uploadParams: {
                width: '264',
                height: '148',
                tip: '尺寸：（1560*878px，比例为16:9）',
                imageUrl: ''
            }
        }
    },
    components: {
        Pagination,
        SingleUpload
    },
    created() {
        this.getLive()
    },
    filters: {
        formatDate(value) {
            var result = ''
            var time = parseInt(value)
            var hr = parseInt(time / 60 / 60)
            var min = parseInt((time / 60) % 60)
            var sec = parseInt(time % 60)
            hr = hr > 9 ? hr : '0' + hr
            min = min > 9 ? min : '0' + min
            sec = sec > 9 ? sec : '0' + sec
            if (hr !== '00') {
                result = hr + ':' + min + ':' + sec
            } else {
                result = '00:' + min + ':' + sec
            }
            return result
        }
    },
    beforeRouteEnter (to, from, next) {
        if (from.name === 'setup') {
            next(vm => {
                vm.handleScrollTop(vm.scroll)
            })
        } else {
            next()
        }
    },
    beforeRouteLeave (to, from, next) {
        if (to.name === 'setup') {
            let scrollContainer = document.getElementById('scrollContainer')
            this.scroll = scrollContainer.scrollTop
        }
        next()
    },
    methods: {
        handleScrollTop(val) {
            this.$nextTick(() => {
                let scrollContainer = document.getElementById('scrollContainer')
                scrollContainer.scrollTop = val
            })
        },
        getLive() {
            this.listLoading = true
            this.queryParams.page = this.pageParams.currentPage
            this.queryParams.per_page = this.pageParams.pageSize
            getLive(this.queryParams).then(res => {
                if (res.code === 0) {
                    this.tableData = res.data.list
                    this.pageParams.total = res.data.total
                }
                this.listLoading = false
            }).catch((res) => {
                this.listLoading = false
            })
        },
        liveLink(id) {
            this.dialogTitle = '直播链接'
            liveHref(id).then(res => {
                if (res.code === 0) {
                    this.serverAddress = res.data.server_address
                    this.streamingKey = res.data.streaming_key
                    this.launchLink = window.location.origin + '/infor?channel_id=' + id
                    this.watchLink = window.location.origin + '/watch?channel_id=' + id
                    this.liveLinkDialog = true
                }
            })
        },
        copy() {
            var clipboard = new Clipboard('.clipboard')
            clipboard.on('success', e => {
                this.$message({
                    type: 'success',
                    message: '复制成功'
                })
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                this.$message({
                    type: 'error',
                    message: '该浏览器不支持复制'
                })
                clipboard.destroy()
            })
        },
        openLive(id) {
            this.liveId = id
            if (this.liveId !== undefined) {
                this.dialogTitle = '编辑直播'
                detailLive(this.liveId).then(res => {
                    if (res.code === 0) {
                        this.liveForm = res.data
                        this.uploadParams.imageUrl = res.data.cover
                        this.liveDialog = true
                    }
                }).catch(res => {})
            } else {
                this.dialogTitle = '新建直播'
                this.liveForm = {}
                this.liveDialog = true
            }
        },
        handleLive() {
            this.$refs['liveForm'].validate((valid) => {
                if (valid) {
                    this.loading = true
                    if (this.liveId !== undefined) {
                        editLive(this.liveForm, this.liveId).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.reload()
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    } else {
                        addLive(this.liveForm).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message.success(res.msg)
                                this.reload()
                            }
                        }).catch(res => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        goSetup(id, type) {
            sessionStorage.setItem('setupActive', type)
            this.$router.push({
                path: '/live/setup',
                query: { id: id }
            })
        },
        search() {
            this.queryParams.page = 1
            this.pageParams.currentPage = 1
            this.getLive()
        },
        // 分页
        pageChange(page) {
            this.pageParams.currentPage = page.currentPage
            this.pageParams.pageSize = page.pageSize
            this.getLive()
        },
        imageUrl(url) {
            this.liveForm.cover = url
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.liveLink-content{
    .liveLink-title{
        font-size: 16px;
        color: $primaryColor;
        border-left: 3px solid $primaryColor;
        height: 16px;
        line-height: 16px;
        padding-left: 12px;
    }
}

.liveForm-content{
    .el-form-item:last-child{
        margin-bottom: 0;
    }
}
</style>
